import { Type } from '@angular/core';

// Header
import { CmsHeaderNavbar } from '@components/cms/header/navbar/navbar';

// Hero
import { CmsHeroRounded } from '@components/cms/hero/rounded/rounded';

const CMS_REGISTRY: Record<string, Type<unknown>> = {
	// ----- Header
	'cms-header-navbar': CmsHeaderNavbar,

	// ----- Hero
	'cms-hero-rounded': CmsHeroRounded,
};

/** Retourne le composant Angular associé à un xtype CMS, ou undefined si introuvable. */
export function getCmsComponent(xtype: string): Type<unknown> | undefined {
	return CMS_REGISTRY[xtype];
}
